module.exports = __webpack_public_path__ + "img/w3_cykel_grey.b8faa8ca.png";